/* tslint:disable:quotemark */
export const environment = {
    production: true,
    showDashboard: true,
    showPaymentMenu: true,
    showUserMenu: true,
    showGroupMenu: true,
    showArchivalMenu: true,
    showProcessesMenu: true,
    showSurveyMenu: true,
    showSurveyActions: true,
    isDevelopmentEnv: false,

    showIntegrationManagement: false,
    showCitcoButtons: false,
    enableExecutiveSummary: true,
    showApplicationActivity: true,
    showImportClient: false,

    APP_BE_URL: "https://testgov.etm2004.com/trust",
    AUTH_BE_URL: "https://testgov.etm2004.com/trust",
    WORKFLOW_URL: "https://testgov.etm2004.com/wfchat/#/workflow",
    CAF_URL: "https://testgov.etm2004.com/caf/#/",
    LOGIN_URL: 'auth/#/login',
  // POST_LOGIN_URL: '/govcc/#/dashboard',
    COOKIE_PATH: window.location.pathname.replace('/auth/', ''),
    BS_EXTRACT_URL: "https://governance.etm2004.com/model/"
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts